import { render, staticRenderFns } from "./single-banner.vue?vue&type=template&id=3340b669&scoped=true"
import script from "./single-banner.vue?vue&type=script&lang=js"
export * from "./single-banner.vue?vue&type=script&lang=js"
import style0 from "./single-banner.vue?vue&type=style&index=0&id=3340b669&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3340b669",
  null
  
)

export default component.exports